import styles from './ToggleSwitch.module.scss';

interface ToggleSwitchProps {
  isOn: boolean;
  onToggle: (value: boolean) => void;
}

const ToggleSwitch = ({ isOn, onToggle }: ToggleSwitchProps) => (
  <div className={styles.toggleWrapper}>
    <label className={styles.switch}>
      <input
        type="checkbox"
        checked={isOn}
        onChange={(e) => onToggle(e.target.checked)}
      />
      <span className={styles.slider}></span>
    </label>
  </div>
);

export default ToggleSwitch;
